/**
 * Throw an error if the condition fails
 */
export function invariant(condition, message = 'no reason specified', ErrorClass = Error) {
    if (!condition) {
        throw new ErrorClass(`Invariant failed: ${message}`);
    }
}
//# sourceMappingURL=invariant.js.map